import Joyride, { STATUS, Step, TooltipRenderProps } from "react-joyride";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomTooltip from "./CustomTooltip";
import colors from "assets/theme/base/colors";


/* ------------------------------------------------------------------
 * Tooltip wrapper component (MOVED OUTSIDE parent)
 * ------------------------------------------------------------------ */

const createJoyrideTooltip =
  (helpersRef: React.MutableRefObject<any>) =>
  (props: TooltipRenderProps) =>
    <CustomTooltip {...props} helpersRef={helpersRef} />;

  interface PepwiseJoyrideProps {
    steps: Step[];
    storageKey?: string;
    runOnPaths?: string[];
  }

const PepwiseJoyride: React.FC<PepwiseJoyrideProps> = ({
  steps,
  storageKey = "pepwise_tour_seen",
  runOnPaths = ["/LandingPage"],
}) => {
  const location = useLocation();
  const helpersRef = useRef<any>(null);
  const [runTour, setRunTour] = useState(false);

  useEffect(() => {
    if (runOnPaths.includes(location.pathname)) {
      const seenTour = localStorage.getItem(storageKey);
      if (!seenTour) {
        setTimeout(() => {
          setRunTour(true);
          localStorage.setItem(storageKey, "true");
        }, 500);
      }
    }
  }, [location.pathname, runOnPaths, storageKey]);

  useEffect(() => {
    const startTour = () => setRunTour(true);
    window.addEventListener("start-joyride", startTour);
    return () => window.removeEventListener("start-joyride", startTour);
  }, []);

  const handleCallback = (data: any) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) setRunTour(false);
  };

  if (!runOnPaths.includes(location.pathname)) return null;

  return (
    <Joyride
    {...({
      steps,
      run: runTour,
      continuous: true,
      showSkipButton: false,
      scrollToFirstStep: true,
      callback: handleCallback,
      disableBeacon: true,
      tooltipComponent: createJoyrideTooltip(helpersRef),
      getHelpers: (helpers: any) => (helpersRef.current = helpers),
      styles: {
        options: {
          zIndex: 9999,
          arrowColor: `${colors.tooltip.background.primary}`,
        },
      },
    } as any)}
  />
  );
};

export default PepwiseJoyride;